import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
	providedIn: 'root',
})
export class DohotService {
	dohotLekohotHovotControl = new FormControl<{ AgentID: string; UserName: string }[]>([]);
	dohotLekohotHovotStyle: 'row' | 'summed' = (localStorage.getItem('dohotLekohotHovotStyle') as 'row' | 'summed') || 'summed';
	constructor() {}

	resetAll() {
		this.dohotLekohotHovotControl.reset([]);
	}

	changeStyle() {
		this.dohotLekohotHovotStyle = this.dohotLekohotHovotStyle === 'row' ? 'summed' : 'row';
		localStorage.setItem('dohotLekohotHovotStyle', this.dohotLekohotHovotStyle);
	}
}
